const formatParamsByChart = (chartParams, chartType, fundsData) => {
  switch (chartType) {
    case 'hypo-chart':
      fundsData.forEach((fund, index) => {
        chartParams.params.customData[fund.name] = fund.growth;
        chartParams.panels[0].indicators.push({
          id: 'custom',
          markerType: 'line',
          datasetId: `${fund.name}`,
          style: {
            color: fund.chartColor,
            width: index === 0 ? 3 : 1.5
          }
        });
      });
      break;

    case 'price-chart':
      chartParams.params.customData[fundsData.fundName] = fundsData.price;
      chartParams.params.style.panel.yAxis.label.format.default.format =
        '$0.2f';
      chartParams.params.style.panel.yAxis.padding = {
        bottom: 30,
        top: 30
      };
      chartParams.params.showFlags = true;
      chartParams.params.showLastCloseFlags = false;
      chartParams.panels[0].indicators.push({
        id: 'custom',
        markerType: 'line',
        datasetId: `${fundsData.fundName}`,
        style: {
          color: '#0053a3',
          width: 3
        }
      });
      break;
    default:
      break;
  }

  return chartParams;
};

const formatBaseChartParams = (data = [], chartType = '') => {
  const baseChartParams = {
    params: {
      customData: {},
      zoomEnabled: false,
      style: {
        panel: {
          border: {
            color: {
              right: '#fff',
              left: '#fff',
              top: '#fff'
            },
            lineDash: {
              top: '1,3'
            }
          },
          grid: {
            horizontal: {
              lineDash: '1,2'
            },
            vertical: {
              alt: {
                color: null
              },
              lineDash: null
            }
          },
          yAxis: {
            padding: {},
            label: {
              padding: {},
              margin: {},
              format: {
                default: {
                  format: '$~s'
                }
              }
            }
          },
          xAxis: {
            label: {
              padding: {
                top: 5
              },
              textAlign: 'center'
            }
          }
        }
      }
    },
    panels: [
      {
        indicators: [],
        params: {}
      }
    ]
  };

  const formattedChartParams = formatParamsByChart(
    baseChartParams,
    chartType,
    data
  );

  return formattedChartParams;
};

const chartHelpers = {
  formatBaseChartParams
};

export default chartHelpers;
